import * as Sentry from "@sentry/react";

import { DASHBOARD_API_URL, SENTRY_DSN, SENTRY_ENVIRONMENT, SENTRY_RELEASE } from "./env";

/** Starts the browser Sentry client. Takes the router so navigations become transactions. */
export function initSentry(
  router: Parameters<typeof Sentry.tanstackRouterBrowserTracingIntegration>[0],
) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE,
    // No DSN means no client at all, which is the local and no-Sentry-stage case.
    enabled: Boolean(SENTRY_DSN),
    enableLogs: true,
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Only the dashboard API gets sentry-trace/baggage; a third party would refuse the preflight.
    tracePropagationTargets: [new URL(DASHBOARD_API_URL).origin],
    denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari(-web)?-extension:\/\//],
    ignoreErrors: [
      "Load failed",
      "Failed to fetch",
      "NetworkError when attempting to fetch resource.",
    ],
  });
}
